import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=5d25245d&scoped=true&"
import script from "./NoticeBar.vue?vue&type=script&lang=js&"
export * from "./NoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=5d25245d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25245d",
  null
  
)

export default component.exports